/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const StudentPaymentMainOptionSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('STUDENT_PAYMENT_MAIN_OPTION')],
    [
        'value',
        /* #__PURE__ */ parsers.maybeNull(/* #__PURE__ */ parsers.exactly('coupon', 'stripe')),
    ],
]);
export class StudentPaymentMainOptionSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return StudentPaymentMainOptionSettingParser.decode(input).map(res => new StudentPaymentMainOptionSetting(res));
    }
    static unsafeDecode(input) {
        return StudentPaymentMainOptionSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return StudentPaymentMainOptionSettingParser.encode(data);
    }
    static schema() {
        return StudentPaymentMainOptionSettingParser.schema();
    }
}
